module.exports = __webpack_public_path__ + "img/cap-20.79885ae4.png";